import { IRootState } from '../../../store'
import { IConfigurationsState } from '../store/configurations.types'

export const getConfigurationsSelector = (state: IRootState): IConfigurationsState => state.configurations

export const getIsTexasServiceSelector = (state: IRootState): boolean =>
  state.configurations.texasExportConfig?.isTexasExport === 1

export const getTexasWristbandReportTypeConfigSelector = (state: IRootState) =>
  state.configurations.texasWristbandReportTypeConfig
